
const languages = [
  {'code': 'vi-VN', 'name': 'VIETNAM'},
  {'code': 'zh-CN', 'name': 'CHINESE'},
  {'code': 'en-US', 'name': 'ENGLISH'}
]

export default languages


// WEBPACK FOOTER //
// ./src/assets/lang/config.js